export const useNotificationSound = () => {
  const playNotificationSound = () => {
    if (import.meta.server) return

    try {
      const audio = new Audio('/sounds/notif-sound.wav')
      audio.volume = 0.5
      audio.play().catch(() => {
        // Browser may block autoplay before user interaction
      })
    } catch {
      // Silently ignore any audio errors
    }
  }

  return { playNotificationSound }
}
